import { render, staticRenderFns } from "./NotificacaoMensagem.vue?vue&type=template&id=28ec290e&scoped=true"
import script from "./NotificacaoMensagem.vue?vue&type=script&lang=js"
export * from "./NotificacaoMensagem.vue?vue&type=script&lang=js"
import style0 from "./NotificacaoMensagem.vue?vue&type=style&index=0&id=28ec290e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec290e",
  null
  
)

export default component.exports